import React from 'react';
import PublicHeader from './PublicHeader';
import './PublicLayout.css';

const PublicLayout = ({ children, onLogin, onSignUp }) => {
  return (
    <div className="public-layout">
      <PublicHeader onLogin={onLogin} onSignUp={onSignUp} />
      <main className="public-content">
        {children}
      </main>
    </div>
  );
};

export default PublicLayout;